import { SVGIconComponent } from './types';

export const ProjectTypePrecinct: SVGIconComponent = ({ className, color, style }) => (
  <svg
    width="18px"
    height="18px"
    viewBox="0 0 18 18"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    style={{ color, ...style }}
    className={className}
  >
    <g id="project-type/precinct" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <path
        d="M0,0 L9,0 L9,18 L0,18 L0,0 Z M7,10 L7,13 L5,13 L5,10 L7,10 Z M4,10 L4,13 L2,13 L2,10 L4,10 Z M7,6 L7,9 L5,9 L5,6 L7,6 Z M4,6 L4,9 L2,9 L2,6 L4,6 Z M7,2 L7,5 L5,5 L5,2 L7,2 Z M4,2 L4,5 L2,5 L2,2 L4,2 Z M18,18 L15.6138521,18 L15.6138521,13.6406954 C15.6138521,13.3841413 15.3330044,13.1275688 15.0521366,13.1275688 L12.946937,13.1275688 C12.6660893,13.1275688 12.4560326,13.3841229 12.4560326,13.6406954 L12.4560326,18 L10,18 L10,5 L18,5 L18,18 Z M17,8 L15,8 L15,11 L17,11 L17,8 Z M13,8 L11,8 L11,11 L13,11 L13,8 Z"
        id="Combined-Shape"
        fill="#848484"
        fillRule="nonzero"
      ></path>
    </g>
  </svg>
);
